module.exports = __webpack_public_path__ + "assets/img/email-857b61df.png";